import { materialsLibrary } from '../common/config/constants'
import Catalog from '../components/Catalog/Catalog'
import Footer from '../components/Footer/Footer'
import Navbar from "../components/Navbar/Navbar"

const MaterialsLibrary = () => {
    return (
        <>
            <Navbar />
            <div className="container shadow-lg">
                {
                    materialsLibrary.details.map((item, index) => {
                        return <Catalog item={item} key={index}/>
                    })
                }
            </div>
            <Footer />
        </>
    )
}

export default MaterialsLibrary;